import type { Route } from '~/core/router'

import * as details from '~/routes/events/details'

export const route: Route = {
  children: [
    {
      path: '/:eventId',
      component: [details.Title, details.DetailsEventsPage],
      init: details.model.initExactEventPage,
      left: details.model.left,
    },
  ],
}
